export default __webpack_public_path__ + "static/media/change-password.7eef348e.svg";